import { html } from "lit";
import { MissingConfig, NetworkError } from "../beam-errors";

const strings = {
  errorTitle: `Beam encountered an error. Please try again.`,
  retry: `Retry`,
};

export const _errorMessage = ({ error, retry }: { error: Error; retry?: (...args: never) => void }) => {
  let details = html``;
  if (error instanceof NetworkError) {
    const response = JSON.stringify(
      {
        status: error.response.status,
        statusText: error.response.statusText,
        url: error.response.url,
        body: error.body,
      },
      null,
      4
    );
    details = html`
      <p><b>Network Response:</b></p>
      <p>${response}</p>
    `;
  }
  if (error instanceof MissingConfig) {
    details = html`
      <p><b>Missing Required Config Options:</b></p>
      <p>${error.missingConfigKeyNames.join(", ")}</p>
    `;
  }
  return html`<div class="beam-error" style="text-align: left">
    <p>${strings.errorTitle} ${retry ? html` <button type="reset" @click="${retry}">${strings.retry}</button>` : ""}</p>
    <br />
    <details>
      <div style="white-space: pre-wrap; font-family: monospace; line-height: 1;">
        ${details}
        <p><b>Message:</b> ${error.message || html`<i>None</i>`}</p>
        <p><b>Stack:</b> ${error.stack}</p>
      </div>
    </details>
    <br />
    <p>Help: <a href="https://www.beamimpact.com">www.beamimpact.com</a></p>
  </div>`;
};
